<template>
  <div style="margin-top: 20px">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div class="userdetail_head_form">
        <!-- <el-form-item label="姓名" prop="real_name">
					<el-input v-model="ruleForm.real_name"></el-input>
				</el-form-item> -->
        <el-form-item label="学历" prop="education">
          <el-select v-model="ruleForm.education" placeholder="请选择学历">
            <el-option
              v-for="item in educationList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="companyName" style="width: 317px">
          <el-input v-model="ruleForm.companyName"></el-input>
        </el-form-item>
      </div>
      <div class="userdetail_head_form">
        <el-form-item label="单位类型" prop="companyType">
          <el-select
            v-model="ruleForm.companyType"
            placeholder="请选择单位类型"
          >
            <el-option
              v-for="item in companyType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职务" prop="position">
          <el-input v-model="ruleForm.position"></el-input>
        </el-form-item>
        <el-form-item label="服务主体" prop="serviceMain">
          <el-select
            v-model="ruleForm.serviceMain"
            placeholder="请选择服务主体"
          >
            <el-option
              v-for="item in serviceMain"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <el-form-item label="证件照" prop="photo">
        <el-upload
          class="avatar-uploader"
          :headers="uploadHeaders"
          :action="upLoadUrl"
          :data="uploadData"
          accept=".png,.jpg,.jpeg"
          :on-success="handleSuccess"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="imageUrl"
            :style="pcShow ? 'width: auto' : ''"
            :src="imageUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"> </i>
          <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过2MB</div> -->
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >下一步</el-button
        >
        <!-- <el-button @click="changeShow = true"></el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  registerInfo,
  // saveInfo,
} from "../../../api/moudles/user.js";
import { upLoadUrl, uploadHeaders, uploadData } from "@/utils/uploadConfig.js";
export default {
  data() {
    return {
      upLoadUrl,
      uploadHeaders,
      uploadData,
      pcShow: true,
      imageUrl: "",
      ruleForm: {
        // real_name: '',
        email: "",
        education: "",
        companyName: "",
        companyType: "",
        position: "",
        serviceMain: 4,
        photo: "",
        memberCode: "",
      },
      rules: {
        // real_name: [{
        // 	required: true,
        // 	message: '请输入姓名',
        // 	trigger: 'blur'
        // }],
        education: [
          {
            required: true,
            message: "请选择学历",
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "change",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "change",
          },
        ],
        companyType: [
          {
            required: true,
            message: "请选择单位类型",
            trigger: "blur",
          },
        ],
        position: [
          {
            required: true,
            message: "请输入职位",
            trigger: "blur",
          },
        ],
        serviceMain: [
          {
            required: true,
            message: "请选择服务主体",
            trigger: "blur",
          },
        ],
        photo: [
          {
            required: true,
            message: "请上传证件照",
            trigger: "blur",
          },
        ],
      },
      // 学历
      educationList: [
        {
          label: "博士",
          value: 1,
        },
        {
          label: "硕士",
          value: 2,
        },
        {
          label: "本科",
          value: 3,
        },
        {
          label: "大专",
          value: 4,
        },
        {
          label: "高中",
          value: 5,
        },
        {
          label: "中专/中技",
          value: 6,
        },
        {
          label: "初中及以下",
          value: 7,
        },
      ],
      // 单位性质
      companyType: [
        {
          label: "中央企业",
          value: 1,
        },
        {
          label: "地方国企",
          value: 2,
        },
        {
          label: "事业单位",
          value: 3,
        },
        {
          label: "民营企业",
          value: 4,
        },
        {
          label: "自由职业",
          value: 5,
        },
        {
          label: "在校学生",
          value: 6,
        },
        {
          label: "其他",
          value: 7,
        },
      ],
      // 服务主体
      serviceMain: [
        // {
        //   label: "法律服务工作委员会",
        //   value: 1,
        // },
        // {
        //   label: "钢木建筑分会",
        //   value: 2,
        // },
        // {
        //   label: "工程技术与BIM应用分会",
        //   value: 3,
        // },
        {
          label: "工程项目管理与建造师分会",
          value: 4,
        },
        // {
        //   label: "古建园林与环境工程分会",
        //   value: 5,
        // },
        // {
        //   label: "航天工程建设分会",
        //   value: 6,
        // },
        // {
        //   label: "核工业建设分会",
        //   value: 7,
        // },
        // {
        //   label: "混凝土分会",
        //   value: 8,
        // },
        // {
        //   label: "建筑安全与机械分会",
        //   value: 9,
        // },
        // {
        //   label: "建筑防水分会",
        //   value: 10,
        // },
        // {
        //   label: "建筑供应链与劳务管理分会",
        //   value: 11,
        // },
        // {
        //   label: "绿色建造与智能建筑分会",
        //   value: 12,
        // },
        // {
        //   label: "深基础与地下空间工程分会",
        //   value: 13,
        // },
        // {
        //   label: "石化建设分会",
        //   value: 14,
        // },
        // {
        //   label: "质量管理与监督检测分会",
        //   value: 15,
        // },
        // {
        //   label: "中小企业分会",
        //   value: 16,
        // },
      ],
    };
  },
  props: ["memberCode"],
  created() {
    if (window.screen.width < 760) {
      this.pcShow = false;
    } else {
      this.pcShow = true;
    }

    const stepMember = JSON.parse(localStorage.getItem("stepMember"));
    if (stepMember) {
      const {
        // real_name,
        email,
        education,
        companyName,
        companyType,
        position,
        serviceMain,
        photo,
        memberCode,
      } = stepMember;
      this.imageUrl = photo;

      this.ruleForm = {
        // real_name,
        email,
        education,
        companyName,
        companyType,
        position,
        photo,
        memberCode,
      };
      if (serviceMain && serviceMain != null) {
        this.ruleForm.serviceMain = serviceMain;
      } else {
        this.ruleForm.serviceMain = 4;
      }
    }
  },
  methods: {
    handleSuccess(file) {
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.imageUrl = file.data;
      this.ruleForm.photo = file.data;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 20MB!");
      }
      return isLt2M;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm["memberCode"]) {
            this.ruleForm["memberCode"] = this.memberCode;
          }
          this.registerInfo(this.ruleForm);
        } else {
          return false;
        }
      });
    },
    // 变更信息
    async registerInfo(params) {
      await registerInfo({
        data: params,
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.msg ? res.msg : "成功",
              type: "success",
            });
            setTimeout(() => {
              // 给父组件发送信息，xiayibu
              this.$emit("addActive");
            }, 1500);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.userView {
  min-height: 200px;
  background-color: #fff;
  margin-bottom: 20px;
  border: 1px solid #fff;
}

.userView:hover {
  border: 1px solid #c22c25;
}

.userdetail_title {
  display: flex;
  justify-content: space-between;
  height: 60px;
  font-weight: 500;
  line-height: 60px;
  padding: 0 20px;
  border-bottom: 1px solid #f2f2f2;
}

.userdetail_title p {
  font-size: 22px;
}

.userdetail_title span {
  cursor: pointer;
}

.userdetail_head {
  padding: 20px;
}

.userdetail_head p {
  margin: 10px 0;
}

.userdetail_head p > span {
  display: inline-block;
  width: 33%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.userdetail_head_form {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px solid #dcdfe6;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.userdetail_body {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}

.userdetail_head__p {
  display: flex;
  justify-content: space-between;
}

.userdetail_body__view {
  width: 33%;
}

.userdetail_body__view > span {
  margin-top: 12px;
  display: inline-block;
}

.userdetail_body__view p {
  min-height: 20px;
}

.userdetail_body__view_view {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  height: 40px;
}

.userdetail_body__pspan {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.userdetail_body__view_view p {
  margin-left: 30px;
  font-size: 15px;
}

.userdetail_body__view_view p:hover {
  cursor: pointer;
  color: #c22c25;
}
</style>
